import styled from 'styled-components';
import { EventList } from '@gv/triage-components';

export const Events = styled(EventList)`
  margin-left: -10px;
`;
